export default [
  {
    path: "/settings/zenhr",
    name: "ZenHRIntegration",
    component: () => import("@/views/zenhr-integrations/index.vue"),
    meta: {
      label: "ZenHR Integration",
      permission: "show_zenhr_integration",
    },
  },
];
